import * as React from 'react';
import { useQuery } from '@apollo/client';

import CurrentUser from 'auth/CurrentUser';
import TriggerComposerButton from './TriggerComposerButton';
import URGENT_MESSAGING_PERMISSION_QUERY from 'chat/queries/UrgentMessagingPermissionQuery.gql';
import type { UrgentMessagingPermission } from 'chat/queries/__generated__/UrgentMessagingPermission';
import { useIsFreeAnnouncementRateLimited } from 'chat/components/FreeAnnouncementRateLimit';

import type { Props as ButtonProps } from 'components/ButtonDeprecated';
import type { OrganizationTarget, GroupTarget } from 'entities/Message';

type Props = {
  label?: React.ReactNode;
  className?: string;
  hideAnnouncements?: boolean | null;
  onComposeSelection?: Function | null;
  initialTarget?: GroupTarget | OrganizationTarget | null;
  full?: boolean;
} & ButtonProps;

export default function TriggerComposerButtonContainer(props: Props) {
  const isRateLimitted = useIsFreeAnnouncementRateLimited();
  const { data } = useQuery<UrgentMessagingPermission>(URGENT_MESSAGING_PERMISSION_QUERY);

  const canViewUrgentMessaging = Boolean(data?.me?.canSendUrgentMessage);
  const currentUser = CurrentUser.getUser();
  const currentUserMutedUntil = currentUser.isMuted() ? currentUser.getMutedUntil() : undefined;

  return (
    <TriggerComposerButton
      {...props}
      label={props.label ?? 'New Message'}
      canViewUrgentMessaging={canViewUrgentMessaging}
      canViewConversations={false}
      currentUserMutedUntil={currentUserMutedUntil}
      isRateLimitted={isRateLimitted}
    />
  );
}
